import { Navbar, Form, Container, Button } from 'react-bootstrap';
import PlotlogicLogo from '../assets/favicon.png';

function Navigation(props) {
	return (
		<>
			<Navbar bg='dark' variant='dark'>
				<Container>
					<Navbar.Brand>
						<img
							alt='Plotlogic Logo'
							src={PlotlogicLogo}
							width='30'
							height='30'
							className='d-inline-block align-top'
						/>{' '}
						Plotlogic QC
					</Navbar.Brand>
					<Navbar.Collapse
						className='justify-content-end'
						style={{ paddingRight: '10px' }}
					>
						<Navbar.Text>Welcome, {props.user.username}</Navbar.Text>
					</Navbar.Collapse>
					<Form className='d-flex'>
						<Button variant='outline-light' onClick={props.signOut}>
							Sign Out
						</Button>
					</Form>
				</Container>
			</Navbar>
		</>
	);
}

export default Navigation;
